<template>
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :heigth="size"
  >
    <!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->
    <path d="M0,0.002h24v24h-24Z" fill="none"></path>
    <path
      fill="currentColor"
      d="M18,2h-12c-1.104,0 -2,0.898 -2,2v4c0,0.256 0.098,0.512 0.293,0.707l4.707,4.708v7.585c0,0.404 0.244,0.769 0.617,0.924c0.124,0.052 0.254,0.076 0.383,0.076c0.26,0 0.516,-0.102 0.707,-0.293l4,-4c0.188,-0.187 0.293,-0.441 0.293,-0.707v-3.586l4.707,-4.707c0.195,-0.195 0.293,-0.45 0.293,-0.707v-4c0,-1.102 -0.896,-2 -2,-2Zm-4.707,10.293c-0.188,0.188 -0.293,0.442 -0.293,0.707v3.586l-2,2v-5.586c0,-0.265 -0.105,-0.52 -0.293,-0.707l-4.707,-4.707v-3.586h12v3.586l-4.707,4.707Z"
    ></path>
  </svg>
</template>

<script>
'use strict'

import mixinIcon from '../mixinIcon'

export default {
  name: 'filter',
  mixins: [mixinIcon]
}
</script>
